import { useState, useEffect } from 'react';

const useModel = (model) => {
  const [,onChange] = useState(model.state);

  useEffect(() => {
    return model.subscribe((newState) => {
      onChange(newState);
    });

  }, [model]);

  return model;
};

export default useModel;